<div class="col-12">
  <p-fileUpload #fileUpload [maxFileSize]="5000000" [customUpload]="true" (uploadHandler)="uploadFile($event)">
    <ng-template pTemplate="content">
      <!-- <ul *ngIf="uploadedFiles.length" class="list-none p-0">
      <li *ngFor="let file of uploadedFiles">
        <button type="button" pButton pRipple (click)="download(file.download_url)" class="p-button-text mr-2">
          {{file.name}}.{{file.extension}}- {{file.size}} bytes - {{file.Creater.name}}
        </button>
      </li>
    </ul> -->
      <p-table #dt [columns]="cols_file" [value]="uploadedFiles" [paginator]="true" [rows]="5"
        [showCurrentPageReport]="true" responsiveLayout="scroll"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[5,15,30]">

        <!-- 材料資訊 -->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <!-- <th *ngFor="let col of columns">
            {{col.header}}
          </th> -->
            <th>
              名稱
            </th>
            <!-- <th>
              格式
            </th> -->
            <th>
              大小
            </th>
            <th>
              上傳者
            </th>
            <th>
              上傳時間
            </th>
            <th>
              <!-- <button pButton pRipple label="" icon="pi pi-plus" class="p-button-rounded mr-2" routerLink="add"></button> -->
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr class="p-selectable-row">
            <!-- <td *ngFor="let col of columns">
            <div *ngIf="col.subfield;then nested_object_content else normal_content"></div>
            <ng-template #nested_object_content>
              {{rowData[col.field][col.subfield]}}
            </ng-template>
            <ng-template #normal_content>
              {{rowData[col.field]}}
            </ng-template>
          </td> -->

            <td>
              <button type="button" pButton pRipple (click)="downloadFile(rowData['download_url'])"
                class="p-button-text mr-2">
                {{rowData['name']}}
                <!-- {{file.name}}.{{file.extension}}- {{file.size}} bytes - {{file.Creater.name}} -->
              </button>
            </td>

            <!-- <td>
              {{rowData['extension']}}
            </td> -->

            <td>
              {{rowData['size']}}
            </td>

            <td>
              {{rowData['Creater']['name']}}
            </td>

            <td>
              {{rowData['created_at'] | date: 'yyyy/MM/dd HH:mm'}}
            </td>

            <td>
              <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2"
                (click)="deleteFile(rowData['file_id'])"></button>
            </td>
          </tr>
        </ng-template>


      </p-table>
    </ng-template>
  </p-fileUpload>
</div>

<!-- <div class="col-12">

  <div class="card">

  </div>

</div> -->



<!-- 確認彈跳視窗 -->
<!-- <p-confirmDialog [style]="{width: '25vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text">
</p-confirmDialog>
<p-toast></p-toast> -->
